/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PaymentGatewayProxy.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AdminStatsGetAdminStatsClientsLeaderboardParams,
  AdminStatsGetAdminStatsRequestsTimeseriesParams,
  ClientLeaderboardEntryDto,
  RequestsTimeseriesDto,
  StatsOverviewDto,
} from '.././schemas';

import { apiFetcher } from '../../http/apiFetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const adminStatsGetAdminStatsOverview = (
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<StatsOverviewDto>(
    { url: `/admin/stats/overview`, method: 'GET', signal },
    options,
  );
};

export const getAdminStatsGetAdminStatsOverviewQueryKey = () => {
  return [`/admin/stats/overview`] as const;
};

export const getAdminStatsGetAdminStatsOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof adminStatsGetAdminStatsOverview>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminStatsGetAdminStatsOverview>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetcher>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminStatsGetAdminStatsOverviewQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminStatsGetAdminStatsOverview>>> = ({
    signal,
  }) => adminStatsGetAdminStatsOverview(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminStatsGetAdminStatsOverview>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminStatsGetAdminStatsOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminStatsGetAdminStatsOverview>>
>;
export type AdminStatsGetAdminStatsOverviewQueryError = unknown;

export function useAdminStatsGetAdminStatsOverview<
  TData = Awaited<ReturnType<typeof adminStatsGetAdminStatsOverview>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminStatsGetAdminStatsOverview>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminStatsGetAdminStatsOverview>>,
          TError,
          Awaited<ReturnType<typeof adminStatsGetAdminStatsOverview>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminStatsGetAdminStatsOverview<
  TData = Awaited<ReturnType<typeof adminStatsGetAdminStatsOverview>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminStatsGetAdminStatsOverview>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminStatsGetAdminStatsOverview>>,
          TError,
          Awaited<ReturnType<typeof adminStatsGetAdminStatsOverview>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminStatsGetAdminStatsOverview<
  TData = Awaited<ReturnType<typeof adminStatsGetAdminStatsOverview>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminStatsGetAdminStatsOverview>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminStatsGetAdminStatsOverview<
  TData = Awaited<ReturnType<typeof adminStatsGetAdminStatsOverview>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminStatsGetAdminStatsOverview>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminStatsGetAdminStatsOverviewQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Bucketed request volume over a trailing window. Used by the dashboard area chart.
 */
export const adminStatsGetAdminStatsRequestsTimeseries = (
  params?: AdminStatsGetAdminStatsRequestsTimeseriesParams,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<RequestsTimeseriesDto>(
    { url: `/admin/stats/requests/timeseries`, method: 'GET', params, signal },
    options,
  );
};

export const getAdminStatsGetAdminStatsRequestsTimeseriesQueryKey = (
  params?: AdminStatsGetAdminStatsRequestsTimeseriesParams,
) => {
  return [`/admin/stats/requests/timeseries`, ...(params ? [params] : [])] as const;
};

export const getAdminStatsGetAdminStatsRequestsTimeseriesQueryOptions = <
  TData = Awaited<ReturnType<typeof adminStatsGetAdminStatsRequestsTimeseries>>,
  TError = unknown,
>(
  params?: AdminStatsGetAdminStatsRequestsTimeseriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminStatsGetAdminStatsRequestsTimeseries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminStatsGetAdminStatsRequestsTimeseriesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminStatsGetAdminStatsRequestsTimeseries>>
  > = ({ signal }) => adminStatsGetAdminStatsRequestsTimeseries(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminStatsGetAdminStatsRequestsTimeseries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminStatsGetAdminStatsRequestsTimeseriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminStatsGetAdminStatsRequestsTimeseries>>
>;
export type AdminStatsGetAdminStatsRequestsTimeseriesQueryError = unknown;

export function useAdminStatsGetAdminStatsRequestsTimeseries<
  TData = Awaited<ReturnType<typeof adminStatsGetAdminStatsRequestsTimeseries>>,
  TError = unknown,
>(
  params: undefined | AdminStatsGetAdminStatsRequestsTimeseriesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminStatsGetAdminStatsRequestsTimeseries>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminStatsGetAdminStatsRequestsTimeseries>>,
          TError,
          Awaited<ReturnType<typeof adminStatsGetAdminStatsRequestsTimeseries>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminStatsGetAdminStatsRequestsTimeseries<
  TData = Awaited<ReturnType<typeof adminStatsGetAdminStatsRequestsTimeseries>>,
  TError = unknown,
>(
  params?: AdminStatsGetAdminStatsRequestsTimeseriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminStatsGetAdminStatsRequestsTimeseries>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminStatsGetAdminStatsRequestsTimeseries>>,
          TError,
          Awaited<ReturnType<typeof adminStatsGetAdminStatsRequestsTimeseries>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminStatsGetAdminStatsRequestsTimeseries<
  TData = Awaited<ReturnType<typeof adminStatsGetAdminStatsRequestsTimeseries>>,
  TError = unknown,
>(
  params?: AdminStatsGetAdminStatsRequestsTimeseriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminStatsGetAdminStatsRequestsTimeseries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Bucketed request volume over a trailing window. Used by the dashboard area chart.
 */

export function useAdminStatsGetAdminStatsRequestsTimeseries<
  TData = Awaited<ReturnType<typeof adminStatsGetAdminStatsRequestsTimeseries>>,
  TError = unknown,
>(
  params?: AdminStatsGetAdminStatsRequestsTimeseriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminStatsGetAdminStatsRequestsTimeseries>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminStatsGetAdminStatsRequestsTimeseriesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Top N clients by request count in the trailing window.
 */
export const adminStatsGetAdminStatsClientsLeaderboard = (
  params?: AdminStatsGetAdminStatsClientsLeaderboardParams,
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<ClientLeaderboardEntryDto[]>(
    { url: `/admin/stats/clients/leaderboard`, method: 'GET', params, signal },
    options,
  );
};

export const getAdminStatsGetAdminStatsClientsLeaderboardQueryKey = (
  params?: AdminStatsGetAdminStatsClientsLeaderboardParams,
) => {
  return [`/admin/stats/clients/leaderboard`, ...(params ? [params] : [])] as const;
};

export const getAdminStatsGetAdminStatsClientsLeaderboardQueryOptions = <
  TData = Awaited<ReturnType<typeof adminStatsGetAdminStatsClientsLeaderboard>>,
  TError = unknown,
>(
  params?: AdminStatsGetAdminStatsClientsLeaderboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminStatsGetAdminStatsClientsLeaderboard>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminStatsGetAdminStatsClientsLeaderboardQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminStatsGetAdminStatsClientsLeaderboard>>
  > = ({ signal }) => adminStatsGetAdminStatsClientsLeaderboard(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminStatsGetAdminStatsClientsLeaderboard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminStatsGetAdminStatsClientsLeaderboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminStatsGetAdminStatsClientsLeaderboard>>
>;
export type AdminStatsGetAdminStatsClientsLeaderboardQueryError = unknown;

export function useAdminStatsGetAdminStatsClientsLeaderboard<
  TData = Awaited<ReturnType<typeof adminStatsGetAdminStatsClientsLeaderboard>>,
  TError = unknown,
>(
  params: undefined | AdminStatsGetAdminStatsClientsLeaderboardParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminStatsGetAdminStatsClientsLeaderboard>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminStatsGetAdminStatsClientsLeaderboard>>,
          TError,
          Awaited<ReturnType<typeof adminStatsGetAdminStatsClientsLeaderboard>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminStatsGetAdminStatsClientsLeaderboard<
  TData = Awaited<ReturnType<typeof adminStatsGetAdminStatsClientsLeaderboard>>,
  TError = unknown,
>(
  params?: AdminStatsGetAdminStatsClientsLeaderboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminStatsGetAdminStatsClientsLeaderboard>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminStatsGetAdminStatsClientsLeaderboard>>,
          TError,
          Awaited<ReturnType<typeof adminStatsGetAdminStatsClientsLeaderboard>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminStatsGetAdminStatsClientsLeaderboard<
  TData = Awaited<ReturnType<typeof adminStatsGetAdminStatsClientsLeaderboard>>,
  TError = unknown,
>(
  params?: AdminStatsGetAdminStatsClientsLeaderboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminStatsGetAdminStatsClientsLeaderboard>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Top N clients by request count in the trailing window.
 */

export function useAdminStatsGetAdminStatsClientsLeaderboard<
  TData = Awaited<ReturnType<typeof adminStatsGetAdminStatsClientsLeaderboard>>,
  TError = unknown,
>(
  params?: AdminStatsGetAdminStatsClientsLeaderboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminStatsGetAdminStatsClientsLeaderboard>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminStatsGetAdminStatsClientsLeaderboardQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
